import { render, staticRenderFns } from "./BatchOfRemittanceReversal.vue?vue&type=template&id=63297108&scoped=true&"
import script from "./BatchOfRemittanceReversal.vue?vue&type=script&lang=js&"
export * from "./BatchOfRemittanceReversal.vue?vue&type=script&lang=js&"
import style0 from "./BatchOfRemittanceReversal.vue?vue&type=style&index=0&id=63297108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63297108",
  null
  
)

export default component.exports